import axios from 'axios'
import store from 'store'
import { notification } from 'ant-design-vue'

// TODO: remove hard coded testing url

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BELEN_API_BASE_URL,
  // baseURL: 'https://mepx-dev-api.progmata.me/api',
  // timeout: 1000,
  // headers: { 'X-Custom-Header': 'foobar' }
})

apiClient.interceptors.request.use((request) => {
  const accessToken = store.get('accessToken')
  if (accessToken) {
    request.headers.Authorization = `Bearer ${accessToken}`
    request.headers.AccessToken = accessToken
  }
  return request
})

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error
    const { data } = response
    const { config } = response

    // we should avoid showing Aunauthorize dmessage on /me url
    if (config.url == '/auth/me') {
      return
    }

    if (data) {
      notification.warning({
        message: data.message ?? data.error,
      })
    }

    return Promise.reject(error)
  }
)

export default apiClient
